import { Box, HStack } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

import Sidebar from './sidebar/Sidebar';
import { useGetUserDetailsQuery } from '../services';
// import { Notification } from '../components';

export const Main = () => {
  useGetUserDetailsQuery();

  return (
    <Box>
      <HStack align="start" bg="custom_gray.2">
        <Box flexBasis="18%" h="calc(100vh - .75rem)" pt="3" bg="white">
          <Sidebar />
        </Box>
        <Box flexBasis="80%" h="calc(100vh - .75rem)" overflowY="auto">
          <Box mt="0" pt="3" h="full">
            <Outlet />
          </Box>
        </Box>
        {/* <Notification /> */}
      </HStack>
    </Box>
  );
};
